module.exports = __webpack_public_path__ + "media/video-bg-1.bc23aa2a.mp4";